import React from 'react'

const Badge = props => (
  <svg
    height={props.height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 22.9"
  >
    <defs>
      <clipPath id="badge3_a">
        <circle cx="11.5" cy="11.5" r="8" fill="none" />
      </clipPath>
      <clipPath id="badge3_b">
        <circle cx="11.6" cy="11.4" r="8.9" fill="none" />
      </clipPath>
      <clipPath id="badge3_c">
        <path fill="none" d="M6.8 12.7l1.2 3 3-3-2.8-1.6-1.4 1.6z" />
      </clipPath>
      <clipPath id="badge3_d">
        <circle cx="17" cy="9.3" r="1" fill="none" />
      </clipPath>
    </defs>
    <g data-name="Warstwa 2">
      <circle cx="11.5" cy="11.5" r="8" fill="#00b4ff" />
      <path
        d="M11.4.5c.2 0 .6-.5.9-.5s.6.6.9.6.7-.4 1-.3.5.7.7.7.8-.2 1.1-.1.4.7.6.8.9 0 1 0 .3.8.6 1 .8 0 1 .2 0 .9.3 1 .8.2 1 .4 0 .8.1 1 .8.3 1 .6-.2.8 0 1 .7.4.8.7-.3.8-.3 1 .7.5.7.8-.4.7-.3 1 .5.6.5.9-.5.7-.5 1 .4.6.4 1-.6.5-.7.7.3.8.2 1-.7.5-.8.7.2.8.1 1-.8.4-.9.6 0 .9-.1 1-.8.3-1 .5 0 .8-.3 1-.8 0-1 .2-.2.8-.4 1-.9 0-1 0-.4.8-.7 1-.8-.3-1-.2-.5.7-.8.7-.7-.3-1-.2-.6.6-.8.6-.7-.5-1-.5-.7.6-1 .6-.6-.6-.9-.6-.7.4-1 .3-.5-.7-.7-.7-.8.2-1 .1-.5-.7-.7-.9-.8.2-1 0-.3-.7-.5-.9-.9 0-1-.2-.2-.8-.3-1-.9-.2-1-.4 0-.8-.2-1-.8-.3-.9-.5.1-.8 0-1-.7-.5-.8-.7.3-.8.2-1-.7-.6-.7-.8.4-.8.4-1-.6-.8-.6-1 .5-.7.5-1-.4-.7-.4-1 .7-.6.7-.8-.3-.8-.2-1 .7-.5.8-.7-.2-.8 0-1 .7-.4.8-.6 0-.9.1-1 .8-.2 1-.4.1-.9.3-1 .8 0 1-.2.2-.8.5-1 .8 0 1 0 .4-.8.6-1 .8.3 1 .2.5-.7.8-.8.7.4 1 .3.5-.6.8-.6.8.4 1 .4z"
        fill="#00b4ff"
      />
      <circle cx="11.5" cy="11.5" r="10.9" fill="#00b4ff" />
      <path
        d="M19.8 11.5a8.3 8.3 0 1 1-8.3-8.3 8.3 8.3 0 0 1 8.3 8.3zM7 3l.4-.2.3.5a1.5 1.5 0 0 1-.3.2.5.5 0 0 1-.4 0 .5.5 0 0 1-.3-.3.5.5 0 0 1 0-.4.5.5 0 0 1 .2-.3H7.2v.2a.5.5 0 0 0-.2 0 .2.2 0 0 0-.1.2.3.3 0 0 0 0 .2.3.3 0 0 0 .1.2.2.2 0 0 0 .2 0h.1V3h-.2zM8 2.8l.1.3-.2.1-.4-1h.3q.4-.2.5.1a.3.3 0 0 1 0 .3l.4.3-.3.1-.3-.3zm0-.2a.1.1 0 0 0 0-.2zM9.4 2.7l-.1-.2-.3.1v.2h-.3v-1h.4l.6.9zm-.2-.4L9 2V2v.4zM10.3 2.5H10l-.1-.7h-.3v-.2l.8-.1v.2H10zM11.4 1.5V2a.4.4 0 0 1 0 .3.5.5 0 0 1-.4 0 .4.4 0 0 1-.3 0 .4.4 0 0 1 0-.3v-.6h.2v.6a.2.2 0 0 0 0 .1.2.2 0 0 0 .1 0 .1.1 0 0 0 .1 0 .3.3 0 0 0 0-.1v-.6zM11.7 2.5l.1-1h.3v.7h.3v.3zM13.2 2.6v-.2h-.3l-.1.2h-.3l.5-1h.3l.2 1zm0-.4V2 2a.7.7 0 0 1 0-.1l-.2.4zM14.2 2a.2.2 0 0 0-.1 0 .4.4 0 0 0-.1.3v.3H14.4v.2a.5.5 0 0 1-.3 0 .4.4 0 0 1-.3-.2.5.5 0 0 1 0-.4.5.5 0 0 1 .1-.2.4.4 0 0 1 .2-.1.5.5 0 0 1 .3 0 .7.7 0 0 1 .2.1l-.1.2h-.1z"
        fill="#fff"
      />
      <path
        d="M14.3 3.2h-.1V3a.1.1 0 0 0 .2 0 .3.3 0 0 0 0-.1l.4-.9.2.1-.3.8a.5.5 0 0 1-.2.3.3.3 0 0 1-.2 0zM15.5 3.4l-.5-.2.4-1 .5.3v.2l-.4-.1v.1l.3.1-.1.2-.3-.1V3l.2.2zM15.7 3.4h.1a.1.1 0 0 1 .1 0 .1.1 0 0 1 0 .1.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.1zm.4 0l-.2-.2.2-.6.3.2zM3.8 17.1a.3.3 0 0 1-.4-.1L3 17 3 17l.7-.5.2.3a.4.4 0 0 1 .1.2.3.3 0 0 1-.2.1zm-.3-.2a.1.1 0 0 0 .1.1c.1 0 .1 0 0-.1zM4.3 18a.5.5 0 0 1-.3.1.4.4 0 0 1-.3-.1.4.4 0 0 1-.1-.4.5.5 0 0 1 .2-.3.5.5 0 0 1 .3-.1.4.4 0 0 1 .3.2.4.4 0 0 1 .1.3.5.5 0 0 1-.2.3zm-.4-.5v.3a.1.1 0 0 0 .1.1.3.3 0 0 0 .2 0 .3.3 0 0 0 .1-.2.1.1 0 0 0 0-.2h-.4zM5 18.2a.1.1 0 0 0-.2 0 .3.3 0 0 0-.2.1c-.1.2-.1.3 0 .4h.2l-.1.2a.7.7 0 0 1-.3-.1.4.4 0 0 1-.1-.3.5.5 0 0 1 .2-.3.6.6 0 0 1 .1-.2.4.4 0 0 1 .3 0 .4.4 0 0 1 .1.1.6.6 0 0 1 .2.3H5z"
        fill="#fff"
      />
      <path
        d="M5.2 19.5l-.5-.5.1-.1.6-.2-.2-.2v-.2l.6.5-.7.2.3.3zM5.8 19.9l.1-.2-.2-.1h-.4l.8-.6.2.2-.2.9zm0 .1H6v.2h-.2a.2.2 0 0 1 0-.1.1.1 0 0 1 0-.1H6h-.1zm.2-.5v-.1a.7.7 0 0 0 0-.1v-.1l-.2.2zM6.5 20.3l-.2-.1.4-.6-.2-.1v-.2l.7.3-.1.2h-.2zM7.6 20.8h-.3v-.5l-.2.3h-.2l.4-.9.2.1-.2.4.1-.1.3-.2.3.1-.4.2z"
        fill="#fff"
      />
      <path
        d="M8.7 20.3l-.1.5a.4.4 0 0 1-.2.2.5.5 0 0 1-.3 0 .4.4 0 0 1-.3-.1.4.4 0 0 1 0-.3L8 20l.2.1-.1.5a.2.2 0 0 0 0 .2.1.1 0 0 0 .2 0l.2-.6zM8.5 21.5h-.1v-.2a.4.4 0 0 0 .1-.1l.3-.8H9l-.2.8a.5.5 0 0 1-.2.3zM9.7 21.4v-.1H9l.5-.8h.3v1zm0-.3v-.3a.5.5 0 0 1 0-.1l-.2.3zm0 .5v.2a.2.2 0 0 1-.1-.1.1.1 0 0 1 0-.1v-.1h.2-.1zM10.6 20.9a.2.2 0 0 0-.2 0 .4.4 0 0 0 0 .2l.1.3a.2.2 0 0 0 .1 0h.1v.2a.6.6 0 0 1-.2 0 .4.4 0 0 1-.3-.2.5.5 0 0 1 0-.3.5.5 0 0 1 0-.3.4.4 0 0 1 .2-.1.5.5 0 0 1 .2 0 .7.7 0 0 1 .3 0l-.1.3h-.1zM11.3 21l.1-.3h.3l-.3.6v.3h-.3v-.3l-.2-.6h.2zM12.8 21a.3.3 0 0 1 0 .2.4.4 0 0 1-.3 0h-.1v.4h-.2l-.1-1h.3a.4.4 0 0 1 .2.1.3.3 0 0 1 .2.2zm-.4 0h-.1zM13.2 21.1v.4H13l-.1-.9h.3c.2 0 .3 0 .4.2a.3.3 0 0 1-.1.2l.3.4h-.3l-.2-.3zm0-.1c.1 0 .2 0 .2-.2s-.1 0-.2 0zM14.6 20.7a.5.5 0 0 1 0 .3.5.5 0 0 1-.6.2.5.5 0 0 1-.2-.3.5.5 0 0 1 0-.3.5.5 0 0 1 .6-.2.5.5 0 0 1 .2.3zm-.6.1c0 .2.1.3.3.2a.3.3 0 0 0 0-.3.4.4 0 0 0 0-.1.2.2 0 0 0-.2 0l-.1.2zM15 20.4l.4-.1.2.4a.9.9 0 0 1-.3.2.4.4 0 0 1-.3 0 .5.5 0 0 1-.3-.6.6.6 0 0 1 .5-.3v.2a.4.4 0 0 0-.1 0 .2.2 0 0 0-.2.1.3.3 0 0 0 0 .2.3.3 0 0 0 .2.2.2.2 0 0 0 .1 0h.1v-.2l-.2.1zM16 20.2v.3l-.2.1-.4-.7.3-.2h.4a.2.2 0 0 1 0 .4l.4.2-.2.1-.3-.2zm-.2-.1c.1 0 .1-.1 0-.2zM17.1 20l-.1-.2-.2.2v.1l-.2.2-.2-1 .2-.1.8.6zm-.3-.3v-.1l-.2-.1v-.1.4zM17.8 19.4l-.6-.3.2.1.2.4h-.1l-.6-.6.3-.2.5.4-.2-.6.2-.2.6.7H18l-.3-.2v-.2l.2.6zM18.4 18.9l-.6-.7.2-.1.6.6zM19 18a.5.5 0 0 1 0 .2.7.7 0 0 1 0 .2h-.1l-.2.1-.1-.1a.6.6 0 0 0 .1 0l.1-.2H18.5a.2.2 0 0 1-.1 0 .3.3 0 0 1-.1 0 .2.2 0 0 1 0-.3.4.4 0 0 1 0-.2.7.7 0 0 1 .3-.2v.2a1 1 0 0 0-.1.1h.1a.6.6 0 0 1 .2 0 .3.3 0 0 1 .2.1z"
        fill="#fff"
      />
      <path
        d="M19.5 17.7l-.1.1-.5-.4-.2.2-.1-.1.4-.6.1.2-.1.1zM20 16.9l-.2.2v.3l-.7-.7.2-.3 1 .3zm-.3-.1h-.4.1l.2.2z"
        fill="#fff"
      />
      <circle cx="21.2" cy="11.4" r=".5" fill="#fff" />
      <circle cx="21" cy="13.2" r=".4" fill="#fff" opacity=".5" />
      <circle cx="20.6" cy="14.8" r=".3" fill="#fff" opacity=".4" />
      <circle cx="21" cy="9.6" r=".4" fill="#fff" />
      <circle cx="20.6" cy="8" r=".3" fill="#fff" />
      <circle cx="1.9" cy="11.4" r=".5" fill="#fff" />
      <circle cx="2" cy="13.2" r=".4" fill="#fff" />
      <circle cx="2.5" cy="14.8" r=".3" fill="#fff" />
      <circle cx="2" cy="9.6" r=".4" fill="#fff" opacity=".5" />
      <circle cx="2.5" cy="8" r=".3" fill="#fff" opacity=".4" />
      <circle cx="11.5" cy="11.5" r="8" fill="#fbc53b" />
      <g clip-path="url(#badge3_a)">
        <g clip-path="url(#badge3_b)" opacity=".2">
          <path fill="#fff" d="M2.7 19.8h17.8v.5H2.7z" />
        </g>
        <path d="M2.9 16.4h17.6v.4l-.1.1H2.9v-.5z" fill="#593730" />
        <path
          d="M19.5 16.6l-7.8.1-7.8-.1c0-.1 3.5-.2 7.8-.2l7.8.2z"
          opacity=".3"
        />
        <path fill="#43302b" d="M4.3 16.9h14.8v4.8H4.3z" />
        <path d="M4.3 16.9h14.8v.6H4.3z" opacity=".2" />
        <path
          d="M14.4 15.7v-4.5a.9.9 0 0 0-.9-.8H9.7a.9.9 0 0 0-1 .8v4.5z"
          fill="#04424c"
        />
        <path
          d="M10.5 7.7a.7.7 0 0 1-1 .6.7.7 0 0 1-.3-.6.7.7 0 0 1 .3-.6.7.7 0 0 1 .4-.1.7.7 0 0 1 .6.7zM14 7.6a.7.7 0 0 1-.4.6.6.6 0 0 1-.3 0 .7.7 0 0 1-.6-.6.7.7 0 0 1 0-.3.7.7 0 0 1 .6-.3.6.6 0 0 1 .2 0h.1a.6.6 0 0 1 .4.6z"
          fill="#593730"
        />
        <path
          d="M13.7 7.6a1.8 1.8 0 0 1 0 .5.3.3 0 0 1 0 .1v.1a2.1 2.1 0 0 1-4.2-.7 2.1 2.1 0 0 1 0-.3V7a2 2 0 0 1 .3-.5 1.4 1.4 0 0 1 .1-.2l.2-.2a1 1 0 0 1 .1-.1 2 2 0 0 1 .9-.4h.5a2.1 2.1 0 0 1 1.5.6l.2.2.2.4a2 2 0 0 1 0 .3 1.6 1.6 0 0 1 0 .3 2.5 2.5 0 0 1 .2.2z"
          fill="#593730"
        />
        <path
          d="M13.4 16.4v-1.2-3.6a.3.3 0 0 0-.3-.3H10a.3.3 0 0 0-.3.3v4.8z"
          fill="#fff"
        />
        <path d="M10.8 11.3s0 .9.8.9a.8.8 0 0 0 .8-.9z" fill="#2e7fdb" />
        <path
          d="M12 10.5v.8a.5.5 0 0 1 0 .2.4.4 0 0 1-.4.3.5.5 0 0 1-.4-.3.5.5 0 0 1 0-.2v-.8z"
          fill="#f1997c"
        />
        <path
          d="M12 10.5v.5a1 1 0 0 1-.4 0 1.2 1.2 0 0 1-.5 0v-.4z"
          fill="#ea7764"
        />
        <path d="M13 8.4a.4.4 0 0 1 .6-.1c.3 0 .1 1.2-.5 1.3z" fill="#f1997c" />
        <path d="M13.2 8.7s.1-.2.3-.2 0 .5-.3.8z" fill="#ea7764" />
        <path
          d="M10.1 8.4a.5.5 0 0 0-.5-.1c-.4 0-.1 1.2.5 1.3z"
          fill="#f1997c"
        />
        <path d="M10 8.7s0-.2-.3-.2 0 .5.3.8z" fill="#ea7764" />
        <path d="M11.6 10.8z" fill="none" />
        <path
          d="M13.3 7.7V9a1.7 1.7 0 0 1-.5 1.2 1.7 1.7 0 0 1-1.2.5h-.1a1.7 1.7 0 0 1-1.6-1.7V7.7A1.7 1.7 0 0 1 11.6 6a1.7 1.7 0 0 1 1.7 1.7z"
          fill="#fdbc95"
        />
        <path
          d="M10.8 8.8a.2.2 0 0 1-.2-.1v-.2a.2.2 0 0 1 .2-.2.2.2 0 0 1 .1.2v.2a.2.2 0 0 1-.1.1zM12.4 8.8a.2.2 0 0 1-.2-.1v-.2a.2.2 0 0 1 .2-.2.2.2 0 0 1 .1.2v.2a.2.2 0 0 1-.1.2z"
          fill="#182632"
        />
        <path
          d="M10.4 7.8a.8.8 0 0 1 .5-.2.1.1 0 0 1 .1.1.1.1 0 0 1 0 .1 1.7 1.7 0 0 0-.5.2.1.1 0 0 1-.1-.1.1.1 0 0 1 0-.1zM12.7 7.8a.7.7 0 0 0-.5-.2.1.1 0 0 0 0 .1.1.1 0 0 0 0 .2 2 2 0 0 1 .4 0h.2v-.1z"
          fill="#593730"
        />
        <path
          d="M12.4 9.4a1.1 1.1 0 0 1 0 .2.7.7 0 0 1-.2.4.8.8 0 0 1-1.2 0 .8.8 0 0 1-.2-.4 1.1 1.1 0 0 1 0-.2z"
          fill="#182632"
        />
        <path
          d="M12.4 9.4a1.1 1.1 0 0 1 0 .2h-1.6a1.1 1.1 0 0 1 0-.2z"
          fill="#fff"
        />
        <path d="M12.2 10a.8.8 0 0 1-1.2 0 2 2 0 0 1 1 0z" fill="#fd5672" />
        <path d="M11.2 9a.4.4 0 0 1 .4-.2.3.3 0 0 1 .3.2z" fill="#f1997c" />
        <rect x="10.1" y="8.9" width=".5" height=".3" rx=".1" fill="#f1997c" />
        <path
          d="M10.1 7.4s0 .7-.2.8a1.5 1.5 0 0 1 0-.8zM13.1 7.4s0 .7.2.8a2 2 0 0 0 0-.8z"
          fill="#593730"
        />
        <rect x="12.6" y="8.9" width=".5" height=".3" rx=".1" fill="#f1997c" />
        <path
          d="M11.3 8.5a.6.6 0 0 1-.5.5h-.1a.5.5 0 0 1-.3-.1l-.1-.1a.6.6 0 0 1 0-.2.4.4 0 0 1 0-.1.6.6 0 0 1 .5-.6.5.5 0 0 1 .3.1.6.6 0 0 1 .2.4z"
          fill="#fffcff"
          opacity=".2"
        />
        <path
          d="M11.3 8.3l-.6.7a.5.5 0 0 1-.3-.1l.8-.8a.6.6 0 0 1 .1.3zM11 8l-.7.8a.6.6 0 0 1 0-.2l.6-.7a.5.5 0 0 1 .2.1z"
          fill="#fffcff"
          opacity=".5"
        />
        <path
          d="M13 8.5a.6.6 0 0 1-.6.5h-.2A.6.6 0 0 1 12 9v-.2a.6.6 0 0 1-.1-.1v-.1a.6.6 0 0 1 .5-.6h.1a.5.5 0 0 1 .2 0 .5.5 0 0 1 0 .2.6.6 0 0 1 .2.2.5.5 0 0 1 0 .2z"
          fill="#fffcff"
          opacity=".2"
        />
        <path
          d="M13 8.3l-.8.7a.6.6 0 0 1-.2-.1l.8-.8a.6.6 0 0 1 .1.3zM12.6 8l-.7.8a.6.6 0 0 1 0-.2l.6-.7a.5.5 0 0 1 .1.1z"
          fill="#fffcff"
          opacity=".5"
        />
        <path
          d="M13.3 8.3a1 1 0 0 0-.3.1.6.6 0 0 1-1.3 0 .6.6 0 0 0-.3 0 .6.6 0 0 1-1.2 0 .9.9 0 0 0-.4-.1h-.1a.2.2 0 0 1 .2-.2.8.8 0 0 1 .3.1.6.6 0 0 1 1.2.2h.2a.5.5 0 0 1 .1 0 .6.6 0 0 1 .7-.5.6.6 0 0 1 .5.3.7.7 0 0 1 .4-.1c.2 0 .2.2.2.2zm-2 .2a.5.5 0 1 0-.5.5.5.5 0 0 0 .5-.5zm1.5 0a.5.5 0 1 0-.4.5.5.5 0 0 0 .4-.5z"
          fill="#182632"
        />
        <path
          d="M13.3 6.1v.2a1.2 1.2 0 0 1-.7.8 1.1 1.1 0 0 1-.4.1A1.2 1.2 0 0 1 11 6a1.1 1.1 0 0 1 .1-.5l.1-.2a1.2 1.2 0 0 1 2.1.7z"
          fill="#593730"
        />
        <path
          d="M11.7 6.1a.9.9 0 0 1-.5.8.8.8 0 0 1-.4.1h-.2a.9.9 0 0 1-.6-.6.4.4 0 0 1 0-.1.9.9 0 0 1 0-.2.9.9 0 0 1 .9-.8.8.8 0 0 1 .4 0 .6.6 0 0 1 .2.2 1 1 0 0 1 .2.6z"
          fill="#593730"
        />
        <path
          d="M10.6 6.8a.7.7 0 0 1-.6.7.7.7 0 0 1-.3-.1l-.2-.2a.7.7 0 0 1-.2-.4.7.7 0 0 1 .6-.7H10.2a.6.6 0 0 1 .4.7zM13.7 6.8a.7.7 0 0 1 0 .3.7.7 0 0 1-.6.3.7.7 0 0 1-.3-.1.4.4 0 0 1-.2-.1.7.7 0 0 1 .5-1.1H13.4a.7.7 0 0 1 .3.7z"
          fill="#593730"
        />
        <path
          d="M14 7.6a.7.7 0 0 1-.4.6v.1a.7.7 0 0 0 0-.2.7.7 0 0 0 .1-.8 1 1 0 0 0 0-.1l-.1-.1V7a1 1 0 0 0 0-.3.7.7 0 0 0-.2-.3.3.3 0 0 0-.2 0V6a1 1 0 0 0-.8-.8 1.1 1.1 0 0 0-1 .2h-.2a.7.7 0 0 0-.6 0 .5.5 0 0 0-.3.5 1 1 0 0 0 0 .2 1 1 0 0 0 0 .2H10a.6.6 0 0 0-.1 0 .6.6 0 0 0-.3.6 1.3 1.3 0 0 0 0 .4.8.8 0 0 0 0 .9.7.7 0 0 1-.3-.6.7.7 0 0 1 .2-.5.7.7 0 0 1-.1-.4.7.7 0 0 1 .6-.7.9.9 0 0 1 .9-.8.8.8 0 0 1 .4 0 1.2 1.2 0 0 1 2 .8.7.7 0 0 1 .4 1 .6.6 0 0 1 .3.5z"
          fill="#481715"
        />
        <path
          d="M16.3 15.7a1.5 1.5 0 0 1-.1.3 1 1 0 0 1-.2.2l-.1.1a.7.7 0 0 1-.2.1.6.6 0 0 1-.2 0H14v-1h1l-1.7-2a2.7 2.7 0 0 1-.1-1.2 3.6 3.6 0 0 1 0-.7l2.8 3.3a.8.8 0 0 1 .2.4 1.5 1.5 0 0 1 0 .3 1.2 1.2 0 0 1 0 .2z"
          fill="#2e7fdb"
        />
        <path
          d="M16.3 15.7a1.5 1.5 0 0 1-.1.3 1 1 0 0 1-.2.2l-.1.1a.7.7 0 0 1-.2.1.6.6 0 0 1-.2 0H14V16l1 .1c.6 0 1.1-.4.9-1a25.7 25.7 0 0 0-2.6-2.8l-.2-.1a3.6 3.6 0 0 1 .2-.8l2.7 3.4a.8.8 0 0 1 .1.3 1.5 1.5 0 0 1 0 .3 1.2 1.2 0 0 1 .1.3z"
          fill="#2e63ca"
        />
        <path
          d="M6.9 15.7a1 1 0 0 0 .1.3 1 1 0 0 0 .2.3h.1l.2.2H8l1.1-.1v-1h-1l1.7-2a2.7 2.7 0 0 0 .1-1.1 3.4 3.4 0 0 0 0-.8L7 14.8a1.4 1.4 0 0 0-.2.3.9.9 0 0 0 0 .3 1.3 1.3 0 0 0 0 .3z"
          fill="#2e7fdb"
        />
        <path
          d="M6.9 15.7a1 1 0 0 0 .1.3 1 1 0 0 0 .2.3h.1l.2.2H8l1.1-.1V16l-1 .1c-.6 0-1.1-.4-.9-1a25.7 25.7 0 0 1 2.6-2.8l.1-.1a3.4 3.4 0 0 0 0-.8L7 14.8a1.4 1.4 0 0 0-.2.3.9.9 0 0 0 0 .3 1.3 1.3 0 0 0 0 .3z"
          fill="#2e63ca"
        />
        <path
          d="M12.2 10a.8.8 0 0 1-1.2 0 .8.8 0 0 0 .6.2.7.7 0 0 0 .5-.2z"
          fill="#d9385e"
        />
        <path
          d="M6.5 11a.2.2 0 0 1-.2 0L6 11l-.3-.2-1.2 1 .8 3.9v.5a.2.2 0 0 1-.2.2.1.1 0 0 1-.1-.2v-.5l-.8-4a.1.1 0 0 1 0-.2l1.3-1a.1.1 0 0 1 .2 0l.4.2.2.1a.2.2 0 0 1 .1.3z"
          fill="#fff"
        />
        <path
          d="M6.5 11a.2.2 0 0 1-.2 0L6 11a.3.3 0 0 1 .2-.2h.1a.2.2 0 0 1 .1.3z"
          fill="#efefef"
        />
        <path
          d="M7.7 11.5h.1l.1.2a.5.5 0 0 1-.7.7.5.5 0 0 1 0-.8.5.5 0 0 1 .5-.1z"
          fill="#fff"
        />
        <path d="M7.7 11.5h.1l.1.2-.7.7a2.9 2.9 0 0 1 .5-1z" fill="#efefef" />
        <path
          d="M6.3 10.8h.3v.3c0 .1-.3.2-.4.1a.3.3 0 0 1 0-.3z"
          fill="#04424c"
        />
        <path
          d="M6.3 10.8h.3v.3c0 .1-.3.2-.4.1a.3.3 0 0 1 0-.3z"
          opacity=".3"
        />
        <path
          d="M8.2 10.9a.2.2 0 0 1 0 .2l-1.4 1.6a.2.2 0 0 1-.4 0 1.2 1.2 0 0 1-.3-1.3 1.4 1.4 0 0 1 .3-.4l.1-.1a1 1 0 0 1 .2-.2 1.2 1.2 0 0 1 1.5.2z"
          fill="#04424c"
        />
        <path
          d="M8.2 10.9a.2.2 0 0 1 0 .2l-1.4 1.6s1-1.3.7-1.8a.5.5 0 0 0-.7-.2 1.2 1.2 0 0 1 1.4.2z"
          fill="#04424c"
        />
        <path
          d="M8.2 10.9a.2.2 0 0 1 0 .2l-1.4 1.6s1-1.3.7-1.8a.5.5 0 0 0-.7-.2 1.2 1.2 0 0 1 1.4.2z"
          opacity=".3"
        />
        <path
          d="M6.3 16.2v.3h-2v-.3a.3.3 0 0 1 .3-.4H6a.3.3 0 0 1 .4.4z"
          fill="#04424c"
        />
        <path d="M4.3 16.2h2v.3h-2z" opacity=".3" />
        <g clip-path="url(#badge3_c)">
          <path fill="#fff" d="M7.9 15.6l3-3.2v3.2H8z" />
        </g>
        <path fill="#efefef" d="M5.4 15.8h-.3v-.2h.3v.2z" />
        <path
          d="M15 13.2l-.4 2.6v.3a.4.4 0 0 1-.3.3H8.9a.4.4 0 0 1-.4-.3v-.3l-.3-2.6a.2.2 0 0 1 .1-.2h6.5a.2.2 0 0 1 .2.2z"
          fill="#04424c"
        />
        <path
          d="M14.7 15.8v.3a.4.4 0 0 1-.4.3H8.9a.4.4 0 0 1-.4-.3v-.3z"
          opacity=".3"
        />
        <circle cx="11.6" cy="14.8" r=".7" fill="#fff" opacity=".2" />
        <path d="M11.6 14.8h-.1v.1h.2l-.1-.2z" fill="#fff" />
        <path
          d="M12 15v-.1-.2l-.1-.1c0-.2-.2-.2-.2-.2h-.1v.1h-.1l-.2.1v.2a.1.1 0 0 0 0 .2h.2a.3.3 0 0 1 0 .1l.2.2.1-.2h.2l.1-.1H12zm-.2-.3v-.1zm-.2.3h-.2v-.2h.2v.3zm0 0zm-.1 0zm-.1-.2h-.1zm0-.1zm.1 0h.1zm.2.2zm-.3-.4l.2.2h-.2a.2.2 0 0 1 0-.2zm-.3.2h.2v.1l-.1-.1zm.2.4H11V15a.4.4 0 0 0 .2 0v.1zm.2.2l-.1-.2h.2v.2zm.2-.2V15h.3-.2z"
          fill="#fff"
        />
        <g clip-path="url(#badge3_d)" opacity=".5">
          <path fill="#fff" d="M16 8.2h2.1v2.1H16z" />
        </g>
        <path
          d="M17 9.8a.5.5 0 0 1-.5-.5.7.7 0 0 1 0-.3v.3-.4h-.3.2a.8.8 0 0 0 0 .3.7.7 0 0 0 .6.7h.1v-.1zM17.8 9.4l-.2.1a.7.7 0 0 0 0-.2.7.7 0 0 0-.6-.7h-.1v.1h.1a.5.5 0 0 1 .5.5.6.6 0 0 1 0 .2v-.1h-.1l.1.3.3-.2zM7.5 8.3c-.7 0-.7.1-.7.8 0-.7-.1-.7-.7-.8.6 0 .6 0 .7-.7 0 .7 0 .7.7.8zM16 5.8c-.6 0-.7 0-.7.7 0-.7 0-.7-.7-.7.6 0 .7-.1.7-.7 0 .6 0 .6.7.7zM20.6 14.9c-.6 0-.6 0-.7.7 0-.7 0-.7-.6-.7.6 0 .6-.1.6-.7.1.6.1.6.8.7z"
          fill="#fff"
        />
        <path fill="#662d91" d="M16.8 13H18v3.3h-1.2z" />
        <path fill="#93278f" d="M18 13.4h1.2v3H18z" />
        <rect
          x="17.1"
          y="15.1"
          width=".3"
          height="1.1"
          rx=".2"
          fill="#f1997c"
        />
      </g>
    </g>
  </svg>
);

export default Badge;



// WEBPACK FOOTER //
// ./src/components/SVG/Badge3.js